import { getNotifications } from '../api/notifications';
import { useEffect, useCallback, useRef } from 'react';
import {
  setPage,
  setSort,
  setData,
  setPerPage,
  setSearch,
} from '@/redux/slices/notifications.slice';
import { useAppDispatch, useAppSelector } from '../redux/store';

const reducerName = 'notifications';

const useNotifications = () => {
  const dispatch = useAppDispatch();
  const timer = useRef<any>(null);
  const reducer = useAppSelector((state) => state[reducerName]);

  const getData = useCallback((params: any) => getNotifications(params), []);

  const dataQuery = (others: any = {}) => {
    return getData({ ...getFilters(), ...others }).then((res) => {
      // console.log(res.data[reducerName]);
      dispatch(setData(res.data[reducerName]));
    });
  };

  const getFilters = () => {
    return {
      search: reducer.search,
      page: reducer.page,
      sort: reducer.sort,
      order: reducer.order,
      perPage: reducer.perPage,
    };
  };

  useEffect(() => {
    dataQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeSort = (sort: string) => {
    const order =
      reducer.sort === sort
        ? reducer.order === 'asc'
          ? 'desc'
          : 'asc'
        : 'asc';
    dispatch(
      setSort({
        sort,
        order,
      }),
    );
    dataQuery({ sort, order });
  };

  const changePage = (page: number) => {
    dispatch(setPage(page));
    dataQuery({ page });
  };

  const changePerPage = (perPage: number) => {
    dispatch(setPerPage(perPage));
    dataQuery({ perPage, page: 1 });
  };
  // this should be debounced
  const changeSearch = (search: string) => {
    dispatch(setSearch(search));
    timer.current && clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      dataQuery({ search, page: 1 });
    }, 500);
  };

  return {
    ...reducer,
    changeSort,
    getData,
    changePage,
    changePerPage,
    changeSearch,
  };
};

export default useNotifications;
